export default {
	SET_WORK_TYPES: "SET_WORK_TYPES",
	SET_LOADING: "SET_LOADING"
}